// src/hooks/useCountryCodes.js

import { useState, useEffect } from 'react';

export const useCountryCodes = () => {
  const [countryCodes, setCountryCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://restcountries.com/v3.1/all?fields=name,idd,cca2');
        const data = await response.json();
        
        const countriesWithCodes = data
          .filter(country => country.idd && country.idd.root) // Filtrar países sin código
          .map((country, index) => {
            const code = country.idd.root + (country.idd.suffixes?.[0] || '');
            return {
              id: `country-${index}-${country.name.common}`, // ID único
              code: code,
              country: country.name.common,
              countryCode: country.cca2
            };
          });
        
        // Ordenar por nombre de país
        const sortedCountries = countriesWithCodes.sort((a, b) => 
          a.country.localeCompare(b.country)
        );
        
        // Añadir códigos comunes al principio con IDs únicos
        const commonCodes = [
          { id: 'common-hn', code: '+504', country: 'Honduras', countryCode: 'HN' },
          { id: 'common-us', code: '+1', country: 'Estados Unidos', countryCode: 'US' },
          { id: 'common-mx', code: '+52', country: 'México', countryCode: 'MX' },
          { id: 'common-gt', code: '+502', country: 'Guatemala', countryCode: 'GT' },
          { id: 'common-sv', code: '+503', country: 'El Salvador', countryCode: 'SV' },
          { id: 'common-ni', code: '+505', country: 'Nicaragua', countryCode: 'NI' },
          { id: 'common-cr', code: '+506', country: 'Costa Rica', countryCode: 'CR' },
          { id: 'common-pa', code: '+507', country: 'Panamá', countryCode: 'PA' },
          { id: 'common-es', code: '+34', country: 'España', countryCode: 'ES' },
        ];
        
        // Filtrar países duplicados en la lista completa que ya estén en commonCodes
        const filteredCountries = sortedCountries.filter(country => 
          !commonCodes.some(common => common.code === country.code && common.country === country.country)
        );
        
        setCountryCodes([...commonCodes, ...filteredCountries]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching country codes:", error);
        setError(error);
        
        // Usar códigos de respaldo en caso de error
        const fallbackCodes = [
          { id: 'fallback-hn', code: '+504', country: 'Honduras', countryCode: 'HN' },
          { id: 'fallback-us', code: '+1', country: 'Estados Unidos', countryCode: 'US' },
          { id: 'fallback-mx', code: '+52', country: 'México', countryCode: 'MX' },
          { id: 'fallback-gt', code: '+502', country: 'Guatemala', countryCode: 'GT' },
          { id: 'fallback-sv', code: '+503', country: 'El Salvador', countryCode: 'SV' },
          { id: 'fallback-ni', code: '+505', country: 'Nicaragua', countryCode: 'NI' },
          { id: 'fallback-cr', code: '+506', country: 'Costa Rica', countryCode: 'CR' },
          { id: 'fallback-pa', code: '+507', country: 'Panamá', countryCode: 'PA' },
          { id: 'fallback-es', code: '+34', country: 'España', countryCode: 'ES' },
        ];
        
        setCountryCodes(fallbackCodes);
        setLoading(false);
      }
    };
    
    fetchCountryCodes();
  }, []);

  return { countryCodes, loading, error };
};
